import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import React, { FC, useEffect, useState, useCallback, useRef, useMemo } from 'react'
import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { Link } from 'react-router-dom'
import { useMutation, useQueryClient } from 'react-query'
import { KTCard, toAbsoluteUrl } from '../../_metronic/helpers'
import { KTCardBody } from '../../_metronic/helpers'
import { KTSVG } from '../../_metronic/helpers'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Maintable } from '../tables/Maintable'
import { Updatecustomer } from './modals/Updatecustomer'
import { Addcustomer } from './modals/Addcutomer'
import { Deletecustomer } from './modals/Deletecustomer'
import { ItemsSummary } from '../topdashboard/ItemsSummary'
import { getCustomers2 } from '../apis/Loadalltabledata'
import { useAllcustomers2, useCustomersSummary, useTopCustomers, useCustomersWithUnpaidAmounts, useDeleteCustomer } from '../contextProviders/Atomqueryprovider'
import CountUp from 'react-countup'
import LoadingBar from 'react-top-loading-bar'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Column } from 'react-table'
import { useAuth } from '../../app/modules/auth'
import { useWindowWidth } from '@react-hook/window-size/throttled'
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween';
import io from 'socket.io-client'
import { useDashboard } from '../contextProviders/Dashboardcontext'
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween);
const API_URL = process.env.REACT_APP_API_URL
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const TARGET_SALES = process.env.REACT_APP_TARGET_STOCK_SALES
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const socket = io('possocket.27mirrors.com')
function isNegative(num: any) {
  if (Math.sign(num) === -1) {
    return true
  }
  return false
}
const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Customers',
    path: '/home',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
// Interfaces for TypeScript
interface UnpaidInvoice {
  invoice_id: string;
  total_amount: number;
  amount_tendered: number;
  unpaid_amount: number;
  date_recorded: string;
  status: string;
  split_payment: string | null;
  payment_type_name: string;
  created_by_user: string;
}
interface CustomerData {
  customer_id: number;
  customer_firstname: string;
  customer_secondname: string;
  customer_name: string;
  customer_phone_number: string;
  customer_email: string;
  total_sales_amount: number;
  total_amount_paid: number;
  total_unpaid_amount: number;
  total_unpaid_credit: number;
  total_unpaid_partial: number;
  total_invoices: number;
  unpaid_invoices_count: number;
  credit_invoices_count: number;
  partial_invoices_count: number;
  paid_invoices_count: number;
  last_sale_date: string | null;
  unpaid_invoices: UnpaidInvoice[];
}
interface CustomerSummary {
  date_recordednow: string;
  date_start: string;
  date_end: string;
  total_invoices: number;
  unique_customers: number;
  hours_selling: number;
  total_sales_amount: number;
  total_amount_tendered: number;
  total_unpaid_amount: number;
  fully_paid_amount: number;
  partially_paid_amount: number;
  unpaid_amount: number;
  fully_paid_count: number;
  partially_paid_count: number;
  unpaid_count: number;
  average_invoice_amount: number;
  highest_invoice_amount: number;
  lowest_invoice_amount: number;
}
interface AllCustomersResponse {
  customers: CustomerData[];
  datalength: number;
  pagination: {
    current_page: number;
    per_page: number;
    total_records: number;
    total_pages: number;
  };
}
interface AllCustomersApiResponse {
  data: AllCustomersResponse;
  success?: boolean;
  message?: string;
}
interface CustomersSummaryApiResponse {
  data: CustomerSummary[];
  success?: boolean;
  message?: string;
}
interface CategoryBreakdown {
  [key: string]: {
    count: number;
    totalValue: number;
    totalUnpaid: number;
  };
}
interface CustomerWithValue extends CustomerData {
  customerValue: number;
}
interface CustomerAnalysis {
  totalCustomers: number;
  totalSalesValue: number;
  totalUnpaidValue: number;
  highValueCustomers: CustomerData[];
  highUnpaidCustomers: CustomerData[];
  inactiveCustomers: CustomerData[];
  categoryBreakdown: CategoryBreakdown;
  averageSales: number;
  topCustomers: CustomerWithValue[];
  riskCustomers: CustomerData[];
}
const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  } return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const truncate = require('truncate')
const CustomersHome = () => {
  const inputRef: any = useRef(null)
  const [time, setTime] = useState<number>(0)
  const queryClientcustomers = useQueryClient()
  const refloadingbar: any = useRef(null)
  const myRef: any = useRef()
  const myRefsearch: any = useRef()
  const { currentUser, logout } = useAuth()
  const [customerData, setCustomerData] = useState<CustomerData[]>([])
  const [table1Dataloaded, settable1Dataloaded] = useState(false)
  const [modalshow, setModalshow] = useState(false)
  const [modalcustomerupdateshow, setModalcustomerupdateshow] = useState(false)
  const [currentsearchItems, setCurrentsearchItems] = useState<string>('')
  const [hiddencolumnsmade, setHiddencolumnsmade] = useState<string[]>(['customer_id'])
  const columndata2 = useMemo(() => [], [])
  const tablename = 'Unpaid Invoices'
  const [modalshowdelete, setModalshowdelete] = useState(false)
  const [statedeletingcustomer, setStatedeletingcustomer] = useState(false)
  const [customertodelete, setCustomertodelete] = useState<CustomerData | null>(null)
  const [customertoUpdate, setCustomertoUpdate] = useState<CustomerData | null>(null)
  const [cannotDeletecustomer, setCannotDeletecustomer] = useState<boolean>(false)
  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [summaryDatanew, setSummaryDatanew] = useState<any>([])
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [startlimitsumdash, setStartlimitsumdash] = useState<number>(0)
  const [database_limitsumdash, setDatabase_limitsumdash] = useState<number>(7)
  const [startlimit, setStartlimit] = useState<number>(0)
  const [itemto_order, setItemto_order] = useState<string>('customer_name')
  const [desorasc, setDesorasc] = useState<string>('ASC')
  const [serversort, setServersort] = useState<any[]>([])
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false)
  const onlyWidth = useWindowWidth()
  const { showDashboard, toggleDashboard } = useDashboard()
  const {
    isLoading: allcustomersloading,
    isSuccess: allcustomerssuccess,
    data: allcustomersdata,
    status: allcustomersstatus,
    isPreviousData: allcustomerpreviousdata,
    isRefetching: allcustomersrefetching,
    refetch: allcustomersrefetch
  } = useAllcustomers2(
    Number(currentUser?.user_id),
    startlimit,
    paginationsize,
    itemto_order,
    desorasc,
    search_item,
    true
  ) as {
    isLoading: boolean;
    isSuccess: boolean;
    data: AllCustomersApiResponse | undefined;
    status: string;
    isPreviousData: boolean;
    isRefetching: boolean;
    refetch: () => void;
  }
  const { mutateAsync: deletecustomersmutateAsync } = useDeleteCustomer(
    customertodelete?.customer_id ?? 0,
    Number(currentUser?.user_id)
  )
  const downloadReport = async (): Promise<void> => {
    try {
      await refloadingbar.current?.continuousStart()

      await allcustomersrefetch()

      if (!allcustomersdata?.data?.customers) {
        console.log('No customer data available to export')
        return
      }

      const allCustomers = allcustomersdata.data.customers.sort((a: CustomerData, b: CustomerData) =>
        (a.customer_name || '').localeCompare(b.customer_name || '')
      )

      const analysis: CustomerAnalysis = {
        totalCustomers: allCustomers.length,
        totalSalesValue: allCustomers.reduce((sum: number, customer: CustomerData) =>
          sum + (Number(customer.total_sales_amount) || 0), 0),
        totalUnpaidValue: allCustomers.reduce((sum: number, customer: CustomerData) =>
          sum + (Number(customer.total_unpaid_amount) || 0), 0),
        highValueCustomers: allCustomers.filter((customer: CustomerData) =>
          (Number(customer.total_sales_amount) || 0) > 10000),
        highUnpaidCustomers: allCustomers.filter((customer: CustomerData) =>
          (Number(customer.total_unpaid_amount) || 0) > 5000),
        inactiveCustomers: allCustomers.filter((customer: CustomerData) =>
          customer.last_sale_date === null || dayjs(customer.last_sale_date).isBefore(dayjs().subtract(6, 'month'))),
        categoryBreakdown: {} as CategoryBreakdown,
        averageSales: 0,
        topCustomers: [],
        riskCustomers: allCustomers.filter((customer: CustomerData) =>
          (Number(customer.total_unpaid_amount) || 0) > (Number(customer.total_sales_amount) || 0) * 0.5)
      }

      allCustomers.forEach((customer: CustomerData) => {
        const category: string = 'General'
        if (!analysis.categoryBreakdown[category]) {
          analysis.categoryBreakdown[category] = {
            count: 0,
            totalValue: 0,
            totalUnpaid: 0
          }
        }
        analysis.categoryBreakdown[category].count++
        analysis.categoryBreakdown[category].totalValue +=
          (Number(customer.total_sales_amount) || 0)
        analysis.categoryBreakdown[category].totalUnpaid += (Number(customer.total_unpaid_amount) || 0)
      })

      const totalSales: number = allCustomers.reduce((sum: number, customer: CustomerData) => {
        return sum + (Number(customer.total_sales_amount) || 0)
      }, 0)
      analysis.averageSales = totalSales / allCustomers.length

      analysis.topCustomers = allCustomers
        .map((customer: CustomerData): CustomerWithValue => ({
          ...customer,
          customerValue: (Number(customer.total_sales_amount) || 0)
        }))
        .sort((a: CustomerWithValue, b: CustomerWithValue) => b.customerValue - a.customerValue)
        .slice(0, 10)

      const wb = XLSX.utils.book_new()

      const customerDataSheet = allCustomers.map((customer: CustomerData) => {
        const salesAmount = Number(customer.total_sales_amount) || 0
        const unpaidAmount = Number(customer.total_unpaid_amount) || 0

        let customerStatus: string = 'Active'
        if (customer.last_sale_date === null) customerStatus = 'Inactive'
        else if (unpaidAmount > salesAmount * 0.5) customerStatus = 'High Risk'

        return {
          'Customer ID': customer.customer_id || '',
          'First Name': customer.customer_firstname || '',
          'Second Name': customer.customer_secondname || '',
          'Full Name': customer.customer_name || '',
          'Phone Number': customer.customer_phone_number || '',
          'Email': customer.customer_email || '',
          'Total Sales': salesAmount,
          'Total Paid': Number(customer.total_amount_paid) || 0,
          'Total Unpaid': unpaidAmount,
          'Total Invoices': Number(customer.total_invoices) || 0,
          'Unpaid Invoices Count': Number(customer.unpaid_invoices_count) || 0,
          'Last Sale Date': customer.last_sale_date ? dayjs(customer.last_sale_date).format('YYYY-MM-DD') : 'N/A',
          'Status': customerStatus
        }
      })

      const wsCustomers = XLSX.utils.json_to_sheet(customerDataSheet)
      XLSX.utils.book_append_sheet(wb, wsCustomers, "Customer Data")

      const unpaidInvoicesData = allCustomers.flatMap((customer: CustomerData) =>
        customer.unpaid_invoices.map((invoice: UnpaidInvoice) => ({
          'Customer ID': customer.customer_id,
          'Customer Name': customer.customer_name,
          'Invoice ID': invoice.invoice_id,
          'Total Amount': invoice.total_amount,
          'Amount Tendered': invoice.amount_tendered,
          'Unpaid Amount': invoice.unpaid_amount,
          'Date': invoice.date_recorded,
          'Status': invoice.status,
          'Split Payment': invoice.split_payment,
          'Payment Type': invoice.payment_type_name,
          'Created By': invoice.created_by_user
        }))
      );

      if (unpaidInvoicesData.length > 0) {
        const wsUnpaidInvoices = XLSX.utils.json_to_sheet(unpaidInvoicesData);
        XLSX.utils.book_append_sheet(wb, wsUnpaidInvoices, "Unpaid Invoices");
      }

      const summaryData = [
        { 'Metric': 'Report Generated', 'Value': dayjs().format('YYYY-MM-DD HH:mm:ss') },
        { 'Metric': 'Total Customers', 'Value': analysis.totalCustomers },
        { 'Metric': 'Total Sales Value', 'Value': analysis.totalSalesValue },
        { 'Metric': 'Total Unpaid Value', 'Value': analysis.totalUnpaidValue },
        { 'Metric': 'Average Sales per Customer', 'Value': analysis.averageSales },
        { 'Metric': 'High Value Customers', 'Value': analysis.highValueCustomers.length },
        { 'Metric': 'High Unpaid Customers', 'Value': analysis.highUnpaidCustomers.length },
        { 'Metric': 'Inactive Customers', 'Value': analysis.inactiveCustomers.length }
      ]

      const wsSummary = XLSX.utils.json_to_sheet(summaryData)
      XLSX.utils.book_append_sheet(wb, wsSummary, "Executive Summary")

      if (Object.keys(analysis.categoryBreakdown).length > 0) {
        const categoryData = Object.entries(analysis.categoryBreakdown).map(([category, data]) => ({
          'Category': category,
          'Customer Count': data.count,
          'Total Sales Value': data.totalValue,
          'Total Unpaid': data.totalUnpaid,
          'Avg Sales per Customer': data.totalValue / data.count
        }))

        const wsCategory = XLSX.utils.json_to_sheet(categoryData)
        XLSX.utils.book_append_sheet(wb, wsCategory, "Category Analysis")
      }

      if (analysis.topCustomers.length > 0) {
        const topCustomersData = analysis.topCustomers.map((customer, index) => ({
          'Rank': index + 1,
          'Customer Name': customer.customer_name,
          'Total Sales': customer.customerValue,
          'Unpaid Amount': customer.total_unpaid_amount,
          'Invoices': customer.total_invoices,
          'Phone': customer.customer_phone_number
        }))

        const wsTopCustomers = XLSX.utils.json_to_sheet(topCustomersData)
        XLSX.utils.book_append_sheet(wb, wsTopCustomers, "Top Customers")
      }

      if (analysis.highUnpaidCustomers.length > 0 || analysis.riskCustomers.length > 0) {
        const alertsData = [
          ...analysis.highUnpaidCustomers.map(customer => ({
            'Alert Type': 'HIGH UNPAID',
            'Customer Name': customer.customer_name || '',
            'Total Unpaid': Number(customer.total_unpaid_amount) || 0,
            'Total Sales': Number(customer.total_sales_amount) || 0,
            'Unpaid Invoices': Number(customer.unpaid_invoices_count) || 0
          })),
          ...analysis.riskCustomers.map(customer => ({
            'Alert Type': 'HIGH RISK',
            'Customer Name': customer.customer_name || '',
            'Total Unpaid': Number(customer.total_unpaid_amount) || 0,
            'Total Sales': Number(customer.total_sales_amount) || 0,
            'Unpaid Invoices': Number(customer.unpaid_invoices_count) || 0
          }))
        ]

        const wsAlerts = XLSX.utils.json_to_sheet(alertsData)
        XLSX.utils.book_append_sheet(wb, wsAlerts, "Risk Alerts")
      }

      const excelBuffer = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
      })

      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })

      const link: HTMLAnchorElement = document.createElement('a')
      const url: string = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `customer_report_${dayjs().format('YYYY-MM-DD_HH-mm')}.xlsx`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error generating customer report:', error)
    } finally {
      refloadingbar.current?.complete()
    }
  }

  const {
    isLoading: summaryloading,
    isSuccess: summarysuccess,
    data: summarydata,
    status: summarystatus,
    isPreviousData: summarypreviousdata,
    isRefetching: summaryrefetching,
    refetch: summaryrefetch
  } = useCustomersSummary(
    Number(currentUser?.user_id),
    new Date(
      dayjs
        .unix(
          dayjs(
            dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME
          ).unix()
        )
        .format('YYYY-MM-DD hh:mm')
    ),
    new Date(
      dayjs(dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).format(
        'YYYY-MM-DD hh:mm'
      )
    ),
    startlimitsumdash,
    database_limitsumdash,
    '%'
  ) as {
    isLoading: boolean;
    isSuccess: boolean;
    data: CustomersSummaryApiResponse | undefined;
    status: string;
    isPreviousData: boolean;
    isRefetching: boolean;
    refetch: () => void;
  }

  const {
    isLoading: topcustomersloading,
    isSuccess: topcustomerssuccess,
    data: topcustomersdata,
    refetch: topcustomersrefetch,
  } = useTopCustomers(
    Number(currentUser?.user_id),
    dayjs().startOf('month').format('YYYY-MM-DD'),
    dayjs().endOf('month').format('YYYY-MM-DD'),
    10,
    'total_sales'
  ) as {
    isLoading: boolean;
    isSuccess: boolean;
    data: CustomerData[] | undefined;
    refetch: () => void;
  }
  const {
    isLoading: unpaidcustomersloading,
    isSuccess: unpaidcustomerssuccess,
    data: unpaidcustomersdata,
    refetch: unpaidcustomersrefetch,
  } = useCustomersWithUnpaidAmounts(
    Number(currentUser?.user_id),
    startlimit,
    paginationsize,
    search_item
  ) as {
    isLoading: boolean;
    isSuccess: boolean;
    data: CustomerData[] | undefined;
    refetch: () => void;
  }

  useEffect(() => {
    if (!allcustomerpreviousdata) {
      queryClientcustomers.prefetchQuery(
        ['allcustomers', startlimit + paginationsize, paginationsize],
        () =>
          getCustomers2(
            Number(currentUser?.user_id),
            startlimit + paginationsize,
            paginationsize,
            itemto_order,
            desorasc,
            search_item,
            true
          )
      )
    }
  }, [
    allcustomerpreviousdata,
    startlimit,
    paginationsize,
    queryClientcustomers,
    itemto_order,
    desorasc,
    search_item,
  ])

  const tabledata = useMemo(() =>
    allcustomersdata?.data?.customers || [],
    [allcustomersdata?.data?.customers, allcustomerssuccess]
  );
  useEffect(() => {
    const fetchData = async () => {
      try {
        await refloadingbar.current?.continuousStart()
        await allcustomersrefetch()
      } catch (error) {
        console.log(error)
      } finally {
        refloadingbar.current.complete()
      }
    }
    fetchData()
  }, [itemto_order, desorasc, search_item])

  useEffect(() => {
    const handleValueChange = () => {
      if (myRefsearch.current.value === '' && myRefsearch.current === document.activeElement) {
        setSearch_item('%')
        setPaginationsize(10)
        setStartlimit(0)
        setItemto_order('customer_name')
        setMovetofirstpage(true)
        setDesorasc('ASC')
      }
    }


    const refSearch = myRefsearch.current
    if (refSearch) {
      refSearch.addEventListener('input', handleValueChange)
    }

    return () => {
      if (refSearch) {
        refSearch.removeEventListener('input', handleValueChange)
      }
    }
  }, [])

  useEffect(() => {
    if (!summaryrefetching && summarysuccess && summarydata) {
      const dataArray = summarydata?.data || [];
      const sorted = [...dataArray].sort((a, b) => (a.date_recordednow > b.date_recordednow ? -1 : 1));
      if (sorted.length > 0) {
        if (dayjs(dayjs(sorted[0].date_recordednow).format('YYYY-MM-DD')).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()) {
          setSummaryDatanew(dataArray)
        } else {
          if (
            dayjs(dayjs(sorted[0].date_recordednow).format('YYYY-MM-DD')).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
            dayjs(dayjs().format("YYYY-MM-DD, h:mm:ss a")).unix() <= dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()
          ) {
            setSummaryDatanew(dataArray)
          } else {
            const currentitemsobj2: CustomerSummary = {
              date_recordednow: dayjs().format('YYYY-MM-DD'),
              date_start: dayjs().format('YYYY-MM-DD'),
              date_end: dayjs().format('YYYY-MM-DD'),
              total_invoices: 0,
              unique_customers: 0,
              hours_selling: 0,
              total_sales_amount: 0,
              total_amount_tendered: 0,
              total_unpaid_amount: 0,
              fully_paid_amount: 0,
              partially_paid_amount: 0,
              unpaid_amount: 0,
              fully_paid_count: 0,
              partially_paid_count: 0,
              unpaid_count: 0,
              average_invoice_amount: 0,
              highest_invoice_amount: 0,
              lowest_invoice_amount: 0
            }
            setSummaryDatanew([...dataArray, currentitemsobj2])
          }
        }
      } else {
        const currentitemsobj2: CustomerSummary = {
          date_recordednow: dayjs().format('YYYY-MM-DD'),
          date_start: dayjs().format('YYYY-MM-DD'),
          date_end: dayjs().format('YYYY-MM-DD'),
          total_invoices: 0,
          unique_customers: 0,
          hours_selling: 0,
          total_sales_amount: 0,
          total_amount_tendered: 0,
          total_unpaid_amount: 0,
          fully_paid_amount: 0,
          partially_paid_amount: 0,
          unpaid_amount: 0,
          fully_paid_count: 0,
          partially_paid_count: 0,
          unpaid_count: 0,
          average_invoice_amount: 0,
          highest_invoice_amount: 0,
          lowest_invoice_amount: 0
        }
        setSummaryDatanew([currentitemsobj2])
      }
    }
  }, [summaryrefetching, summarysuccess, summarydata])

  useEffect(() => {
    if (serversort.length > 0) {
      setItemto_order(serversort[0].id)
      setDesorasc(serversort[0].desc ? 'DESC' : 'ASC')
    } else {
      setItemto_order('customer_name')
      setDesorasc('ASC')
    }
  }, [serversort])

  useEffect(() => {
    if (topcustomerssuccess && summarysuccess) {
      setStatusnow(true)
    }
  }, [topcustomerssuccess, summarysuccess])

  useEffect(() => {
    if (statusnow && !topcustomersloading && !summaryrefetching) {
      setStatusnow2(true)
    }
  }, [topcustomersloading, summaryrefetching, statusnow])

  const deleteselectedcustomer = async () => {
    if (!customertodelete) return
    setStatedeletingcustomer(true)
    setCannotDeletecustomer(false)
    deletecustomersmutateAsync(undefined, {
      onSuccess: () => {
        setStatedeletingcustomer(false)
        setModalshowdelete(false)
      },
      onError(error) {
        console.log(error)
        setStatedeletingcustomer(false)
        setCannotDeletecustomer(true)
      },
    })
  }

  const showModaldelete = (x: CustomerData) => {
    setModalshowdelete(true)
    setStatedeletingcustomer(false)
    setCannotDeletecustomer(false)
    setCustomertodelete(x)
  }

  const filteredsubdata = (rowdata: any): number => {
    const customer = rowdata.original as CustomerData;
    return customer.unpaid_invoices.length;
  }

  const filteredtablesubData = (rowdata: any): UnpaidInvoice[] => {
    const customer = rowdata.original as CustomerData;
    return customer.unpaid_invoices.sort((a, b) => (a.date_recorded > b.date_recorded ? -1 : 1));
  }

  const tabledatalength = useMemo(
    () => allcustomersdata?.data?.datalength || 0,
    [allcustomersdata?.data?.datalength, allcustomerssuccess]
  )

  const showModal = () => {
    setModalshow(true)
  }

  const showcustomerupdateModal = (x: CustomerData) => {
    setCustomertoUpdate(x)
    setModalcustomerupdateshow(true)
  }

  const handlesearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const inputValue = (event.target as HTMLInputElement).value
      if (inputValue) {
        setSearch_item(inputValue + '%')
      } else {
        setSearch_item('%')
      }
      setPaginationsize(10)
      setStartlimit(0)
      setItemto_order('customer_name')
      setMovetofirstpage(true)
      setDesorasc('ASC')
    }
  }

  const handlesearchKeyDown2 = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    const inputValue = myRefsearch.current.value
    if (inputValue) {
      setSearch_item(inputValue + '%')
    } else {
      setSearch_item('%')
    }
    setPaginationsize(10)
    setStartlimit(0)
    setItemto_order('customer_name')
    setMovetofirstpage(true)
    setDesorasc('ASC')
  }

  const handleinputs = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '') {
      setSearch_item('%')
      setPaginationsize(10)
      setStartlimit(0)
      setItemto_order('customer_name')
      setMovetofirstpage(true)
      setDesorasc('ASC')
    }
  }

  socket.on('update', (_arg: any) => {
    (async () => {
      try {
        await refloadingbar.current?.continuousStart()
        await allcustomersrefetch()
        await summaryrefetch()
        await topcustomersrefetch()
      } catch (error) {
        console.log(error)
      } finally {
        await refloadingbar.current?.complete()
      }
    })()
  })

  const columndata1: ReadonlyArray<Column<CustomerData>> = [
    {
      Header: () => null,
      id: 'expander',
      Cell: ({ row }: any) => {
        const customer = row.original as CustomerData;
        if (
          customer.total_unpaid_amount > 0 ||
          customer.total_unpaid_credit > 0 ||
          customer.total_unpaid_partial > 0
        ) {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <span className='svg-icon svg-icon-primary'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              ) : (
                <span className='svg-icon svg-icon-primary'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              )}
            </span>
          )
        }
        return null
      },
    },
    {
      Header: 'Name',
      accessor: 'customer_name',
      Cell: ({ cell: { value }, row }) => (
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-50px me-5'>
            <div className='symbol-label bg-light'>
              <img
                src={toAbsoluteUrl('/media/icons/duotune/communication/com006.svg')}
                alt=''
                className='h-100'
              />
            </div>
          </div>
          <div className='d-flex justify-content-start flex-column'>
            <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.customer_name}>
              {truncate(row.original.customer_name, 20)}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              {row.original.customer_phone_number}
              </span>
              <span className='badge badge-light-dark me-1' title={row.original.customer_email}>
                {truncate(row.original.customer_email, 20)}
              </span>
           
          </div>
        </div>
      ),
    },
    {
      Header: 'T.Sales',
      accessor: 'total_sales_amount',
      Cell: ({ cell: { value }, row }) => (
        <>
          <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
          <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
            Paid: {addCommas(row.original.total_amount_paid)} {CURRENCY_APP}
          </span>
        </>
      ),
    },
    {
      Header: 'Unpaid',
      accessor: 'total_unpaid_amount',
      Cell: ({ cell: { value }, row }) => (
        <>
          <span className='text-primary fw-bolder fs-6 text-nowrap'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
          <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
            Invoices: {addCommas(row.original.unpaid_invoices_count)}
          </span>
        </>
      ),
    },
    {
      Header: 'id',
      accessor: 'customer_id',
      Cell: ({ cell: { value } }) => (
        <span className='text-primary fw-bolder fs-6 text-nowrap'>
          {value}
        </span>
      ),
    },
    {
      Header: () => null,
      id: 'expander2',
      Cell: ({ row }: any) => (
        <div className='d-flex justify-content-end flex-shrink-0'>
          <a
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={() => showcustomerupdateModal(row.original)}
          >
            <span className='svg-icon svg-icon-3'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  opacity='0.3'
                  d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                  fill='black'
                ></path>
                <path
                  d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                  fill='black'
                ></path>
              </svg>
            </span>
          </a>
          <a
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
            onClick={() => showModaldelete(row.original)}
          >
            <span className='svg-icon svg-icon-3'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width={24}
                height={24}
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                  fill='#f1416c'
                />
                <path
                  opacity='0.5'
                  d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                  fill='#f1416c'
                />
                <path
                  opacity='0.5'
                  d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                  fill='#f1416c'
                />
              </svg>
            </span>
          </a>
        </div>
      ),
    },
  ]

  const columndata3: ReadonlyArray<Column<CustomerData>> = [
    {
      Header: () => null,
      id: 'expander',
      Cell: ({ row }: any) => {
        const customer = row.original as CustomerData;
        if (
          customer.total_unpaid_amount > 0 ||
          customer.total_unpaid_credit > 0 ||
          customer.total_unpaid_partial > 0
        ) {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <span className='svg-icon svg-icon-primary'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              ) : (
                <span className='svg-icon svg-icon-primary'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              )}
            </span>
          )
        }
        return null
      },
    },
    {
      Header: 'Name',
      accessor: 'customer_name',
      Cell: ({ cell: { value }, row }) => (
        <div className='d-flex align-items-center'>
          <div className='d-flex justify-content-start flex-column'>
            <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.customer_name}>
              {truncate(row.original.customer_name, 15)}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap' >
              {row.original.customer_phone_number}
              </span>
              <span className='badge badge-light-dark me-1' title={row.original.customer_email}>
                {truncate(row.original.customer_email, 20)}
              </span>
            
          </div>
        </div>
      ),
    },
    {
      Header: 'id',
      accessor: 'customer_id',
      Cell: ({ cell: { value } }) => (
        <span className='text-primary fw-bolder fs-6 text-nowrap'>
          {value}
        </span>
      ),
    },
    {
      Header: () => null,
      id: 'expander2',
      Cell: ({ row }: any) => (
        <div className='d-flex justify-content-end flex-shrink-0'>
          <a
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={() => showcustomerupdateModal(row.original)}
          >
            <span className='svg-icon svg-icon-3'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  opacity='0.3'
                  d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                  fill='black'
                ></path>
                <path
                  d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                  fill='black'
                ></path>
              </svg>
            </span>
          </a>
          <a
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
            onClick={() => showModaldelete(row.original)}
          >
            <span className='svg-icon svg-icon-3'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width={24}
                height={24}
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                  fill='#f1416c'
                />
                <path
                  opacity='0.5'
                  d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                  fill='#f1416c'
                />
                <path
                  opacity='0.5'
                  d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                  fill='#f1416c'
                />
              </svg>
            </span>
          </a>
        </div>
      ),
    },
  ]

  const columndata5: ReadonlyArray<Column<CustomerData>> = [
    {
      Header: () => null,
      id: 'expander',
      Cell: ({ row }: any) => {
        const customer = row.original as CustomerData;
        if (
          customer.total_unpaid_amount > 0 ||
          customer.total_unpaid_credit > 0 ||
          customer.total_unpaid_partial > 0
        ) {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <span className='svg-icon svg-icon-primary'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              ) : (
                <span className='svg-icon svg-icon-primary'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                    <g fill='none' fillRule='evenodd'>
                      <path d='M0 0L24 0 24 24 0 24z'></path>
                      <path
                        fill='#009ef7'
                        fillRule='nonzero'
                        d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                      ></path>
                    </g>
                  </svg>
                </span>
              )}
            </span>
          )
        }
        return null
      },
    },
    {
      Header: 'Name',
      accessor: 'customer_name',
      Cell: ({ cell: { value }, row }) => (
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-50px me-5'>
            <div className='symbol-label bg-light'>
              <img
                src={toAbsoluteUrl('/media/icons/duotune/communication/com006.svg')}
                alt=''
                className='h-100'
              />
            </div>
          </div>
          <div className='d-flex justify-content-start flex-column'>
            <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.customer_name}>
              {truncate(row.original.customer_name, 20)}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              {row.original.customer_phone_number}
              </span>
              <span className='badge badge-light-dark d-block me-1' title={row.original.customer_email}>
                {truncate(row.original.customer_email, 20)}
              
            </span>
          </div>
        </div>
      ),
    },
    {
      Header: 'T.Sales',
      accessor: 'total_sales_amount',
      Cell: ({ cell: { value }, row }) => (
        <>
          <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
          <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
            Paid: {addCommas(row.original.total_amount_paid)} {CURRENCY_APP}
          </span>
        </>
      ),
    },
    {
      Header: 'Unpaid',
      accessor: 'total_unpaid_amount',
      Cell: ({ cell: { value }, row }) => (
        <>
          <span className='text-primary fw-bolder fs-6 text-nowrap'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
          <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
            Invoices: {addCommas(row.original.unpaid_invoices_count)}
          </span>
        </>
      ),
    },
    {
      Header: 'id',
      accessor: 'customer_id',
      Cell: ({ cell: { value } }) => (
        <span className='text-primary fw-bolder fs-6 text-nowrap'>
          {value}
        </span>
      ),
    },
    {
      Header: () => null,
      id: 'expander2',
      Cell: ({ row }: any) => (
        <div className='d-flex justify-content-end flex-shrink-0'>
          <a
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={() => showcustomerupdateModal(row.original)}
          >
            <span className='svg-icon svg-icon-3'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  opacity='0.3'
                  d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                  fill='black'
                ></path>
                <path
                  d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                  fill='black'
                ></path>
              </svg>
            </span>
          </a>
          <a
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
            onClick={() => showModaldelete(row.original)}
          >
            <span className='svg-icon svg-icon-3'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width={24}
                height={24}
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                  fill='#f1416c'
                />
                <path
                  opacity='0.5'
                  d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                  fill='#f1416c'
                />
                <path
                  opacity='0.5'
                  d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                  fill='#f1416c'
                />
              </svg>
            </span>
          </a>
        </div>
      ),
    },
  ]

  const columndata2sub: ReadonlyArray<Column<UnpaidInvoice>> = [
    {
      Header: 'ID',
      accessor: 'invoice_id',
      Cell: ({ cell: { value } }) => (
        <span className='text-primary fw-bolder fs-6 text-nowrap'>
          {value}
        </span>
      ),
    },
    {
      Header: 'Total',
      accessor: 'total_amount',

      Cell: ({ cell: { value }, row }) => (
        <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {addCommas(value.toFixed(2))} {CURRENCY_APP}
          </span>

          <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
            <span
              className={`${row.original.payment_type_name === 'MPESA'
                ? 'badge badge-light-success'
                : row.original.payment_type_name === 'CHEQUE'
                  ? 'badge badge-light-warning'
                  : row.original.payment_type_name === 'MPESACASH'
                    ? 'badge badge-light-info'
                    : 'badge badge-light-primary'
                }`}
            >
              {row.original.payment_type_name}
            </span>
          </span>
        </>
      ),
    },
    
    {
      Header: 'U.Amount',
      accessor: 'unpaid_amount',
      Cell: ({ row }) => {
        const invoice = row.original;
        return (
          <>
          <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
            {addCommas((invoice.status === "NOT PAID" ? Number(invoice.total_amount) : Number(invoice.unpaid_amount)).toFixed(2))} {CURRENCY_APP}
          </span>
          <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
          {addCommas((invoice.status === "NOT PAID" ? 0 : Number(invoice.amount_tendered)).toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        );
      },
    },
    {
      Header: 'Date',
      accessor: 'date_recorded',
      Cell: ({ cell: { value } }) => (
        <>
        <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
        {dayjs(value).format('LL')}
      </span>
      <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
        {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
      </span>
      </>
      ),
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ row }) => {
        const invoice = row.original;
        
        const getBadgeStyles = (status: any) => {
          switch (status) {
            case 'PAID':
              return 'badge badge-light-success';
            case 'PARTIAL':
              return 'badge badge-light-warning text-dark';
            case 'NOT PAID':
              return 'badge badge-light-danger';
            case 'CREDIT':
              return 'badge badge-light-info';
            default:
              return 'badge badge-light-secondary';
          }
        };
    
        return (
          <span className={getBadgeStyles(invoice.status)}>
            {invoice.status}
          </span>
        );
      }
    },
    
    {
      Header: 'Created By',
      accessor: 'created_by_user',
    },
  ]

  const columndata4sub: ReadonlyArray<Column<UnpaidInvoice>> = [
    {
      Header: 'ID',
      accessor: 'invoice_id',
      Cell: ({ row }) => {
        const invoice = row.original;
        return (
          <>
            <span className='text-primary fw-bolder fs-6 text-nowrap'>
              {invoice.invoice_id}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              Unpaid: {addCommas((invoice.status === "NOT PAID" ? Number(invoice.total_amount) : Number(invoice.unpaid_amount)).toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        )
      },
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ row }) => {
        const invoice = row.original;
        
        const getBadgeStyles = (status: any) => {
          switch (status) {
            case 'PAID':
              return 'badge badge-light-success';
            case 'PARTIAL':
              return 'badge badge-light-warning text-dark';
            case 'NOT PAID':
              return 'badge badge-light-danger';
            case 'CREDIT':
              return 'badge badge-light-info';
            default:
              return 'badge badge-light-secondary';
          }
        };
    
        return (
          <span className={getBadgeStyles(invoice.status)}>
            {invoice.status}
          </span>
        );
      }
    },
  ]

  const columndata6sub: ReadonlyArray<Column<UnpaidInvoice>> = [
    {
      Header: 'ID',
      accessor: 'invoice_id',
      Cell: ({ cell: { value } }) => (
        <span className='text-primary fw-bolder fs-6 text-nowrap'>
          {value}
        </span>
      ),
    },
    {
      Header: 'Total',
      accessor: 'total_amount',
      Cell: ({ cell: { value }, row }) => {
        const invoice = row.original;
        const getBadgeStyles = (status: any) => {
          switch (status) {
            case 'PAID':
              return 'badge badge-light-success';
            case 'PARTIAL':
              return 'badge badge-light-warning text-dark';
            case 'NOT PAID':
              return 'badge badge-light-danger';
            case 'CREDIT':
              return 'badge badge-light-info';
            default:
              return 'badge badge-light-secondary';
          }
        };
        return (
          <>
            <span className='text-dark fw-bolder fs-6 text-nowrap'>
              {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
        </span>
         <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
         {addCommas(
           (
             invoice.status === "NOT PAID"
               ? Number(invoice.total_amount)
               : Number(invoice.unpaid_amount)
           ).toFixed(2)
         )} {CURRENCY_APP}
       </span>
       </>
        )
      
    }
    },
   
    {
      Header: 'Date',
      accessor: 'date_recorded',
      Cell: ({ cell: { value } }) => (
        <>
        <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
        {dayjs(value).format('LL')}
      </span>
      <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
        {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
      </span>
      </>
      ),
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ row }) => {
        const invoice = row.original;
        
        const getBadgeStyles = (status: any) => {
          switch (status) {
            case 'PAID':
              return 'badge badge-light-success';
            case 'PARTIAL':
              return 'badge badge-light-warning text-dark';
            case 'NOT PAID':
              return 'badge badge-light-danger';
            case 'CREDIT':
              return 'badge badge-light-info';
            default:
              return 'badge badge-light-secondary';
          }
        };
    
        return (
          <span className={getBadgeStyles(invoice.status)}>
            {invoice.status}
          </span>
        );
      }
    },
    
  ]

  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={usersBreadcrumbs}>Customer list</PageTitle>
      {showDashboard && (
        <div className='row g-5 g-xl-8'>
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='120px'
              cardName='T.Sales'
              chartName='Customer Sales'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={Math.abs(Math.max(...(summaryDatanew.map((x: any) => x.total_sales_amount) || [0])))}
              chartCategories={summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL'))}
              chartData={summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.total_sales_amount)}
              values={
                <div className='fs-2 fw-bolder d-block'>
                  <CountUp
                    className='text-primary'
                    end={summaryDatanew
                      .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))
                      .map((x: any) => x.total_sales_amount)[0]}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='fs-6 text-primary'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {summaryDatanew[1]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {dayjs(summaryDatanew[1].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[1].total_sales_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                      {summaryDatanew[2]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {dayjs(summaryDatanew[2].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[2].total_sales_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </span>
              }
            />
          </div>
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='danger'
              chartHeight='120px'
              cardName='T.Unpaid'
              chartName='Customer Unpaid Amounts'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={Math.abs(Math.max(...(summaryDatanew.map((x:any) => x.total_unpaid_amount) || [0])))}
              chartCategories={summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL'))}
              chartData={summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.total_unpaid_amount)}
              values={
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className='text-danger'
                    end={summaryDatanew
                      .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))
                      .map((x: any) => x.total_unpaid_amount)[0] || 0}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='text-danger fs-6'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {summaryDatanew[1]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {dayjs(summaryDatanew[1].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[1].total_unpaid_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                      {summaryDatanew[2]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {dayjs(summaryDatanew[2].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[2].total_unpaid_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </span>
              }
            />
          </div>
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-5 mb-xl-8'
              chartColor='info'
              chartHeight='120px'
              statusnow={statusnow}
              statusnow2={statusnow2}
              cardName='T.Customers'
              isCurrency= {false}
              chartName='Customer Growth'
              yaxisHeight={Math.abs(Math.max(...(summaryDatanew.map((x: any) => x.unique_customers) || [0])))}
              chartCategories={summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL'))}
              chartData={summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.unique_customers)}
              values={
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className='text-info'
                    end={summaryDatanew.sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))[0]?.unique_customers || 0}
                    duration={2}
                    decimals={0}
                    separator=','
                  />
                </div>
              }
              values2={
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {summaryDatanew[1]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-info'>
                              {dayjs(summaryDatanew[1].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[1].unique_customers}
                              duration={2}
                              decimals={0}
                              separator=','
                            />
                          </td>
                        </tr>
                      )}
                      {summaryDatanew[2]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-info'>
                              {dayjs(summaryDatanew[2].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[2].unique_customers}
                              duration={2}
                              decimals={0}
                              separator=','
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </span>
              }
            />
          </div>
        </div>
      )}
      <KTCard>
        <KTCardBody className='py-4'>
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2'>
                <h3 className='fw-bolder my-2'>Update Customer</h3>          
   
                </div>
            </div>
            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                <div className='d-flex align-items-center position-relative my-1'>
                  <a href='#' onClick={handlesearchKeyDown2}>
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-1 position-absolute me-4 top-0 end-0 mt-3 text-primary'
                    />
                  </a>
                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-5 pe-12'
                    placeholder='Search Customers'
                    ref={myRefsearch}
                    onChange={handleinputs}
                    onKeyDown={handlesearchKeyDown}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2 me-auto'>
                <a
                  className='btn btn-info btn-sm mb-2 me-2'
                  href='#'
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault()
                    downloadReport()
                  }}
                >
                  <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '↓' : 'Download Report'}
                </a>
              </div>
              <div className='mb-2' style={{ display: 'inline-grid', gridTemplateColumns: '1fr' }}>
                <a
                  className='btn btn-success btn-sm mb-2 me-2'
                  href='#'
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault()
                    showModal()
                  }}
                  title={onlyWidth <= 576 ? 'Add Customer' : ''}
                >
                  <KTSVG path='/media/icons/duotune/communication/com006.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '+' : 'Add Customer'}
                </a>
              </div>
            </div>
          </div>
          <Maintable
            tabledata={allcustomerssuccess ? tabledata : []}
            startlimit={startlimit}
            hiddencolumnsmade={hiddencolumnsmade}
            setstartlimit={setStartlimit}
            paginationsize={paginationsize}
            pageCount={pageCount}
            setPageCount={setPageCount}
            setPaginationsize={setPaginationsize}
            columndata={onlyWidth <= 576 ? columndata3 : onlyWidth > 576 && onlyWidth <= 768 ? columndata5 : columndata1}
            tabledata2={tabledata}
            columndata2={onlyWidth <= 576 ? columndata4sub : onlyWidth > 576 && onlyWidth <= 768 ? columndata6sub : columndata2sub}
            table1loaded={allcustomersstatus === 'success'}
            table2loaded={allcustomersstatus === 'success'}
            movetofirstpage={movetofirstpage}
            setMovetofirstpage={setMovetofirstpage}
            tablename={tablename}
            tablelength={allcustomersstatus === 'success' ? tabledatalength : 0}
            filteredsubdata={filteredsubdata}
            filteredtablesubData={filteredtablesubData}
            setServersort={setServersort}
          />
        </KTCardBody>
      </KTCard>
      <Addcustomer
        show={modalshow}
        handleClose={() => setModalshow(false)}
      />
      {modalcustomerupdateshow && customertoUpdate && (
        <Updatecustomer
          show={modalcustomerupdateshow}
          customertoUpdate={customertoUpdate}
          allcustomersrefetch={allcustomersrefetch}
          summaryrefetch={summaryrefetch}
          topcustomersrefetch={topcustomersrefetch}
          handleClose={() => setModalcustomerupdateshow(false)}
        />
      )}
      {modalshowdelete && customertodelete && (
        <Deletecustomer
          show={modalshowdelete}
          deleteselectedcustomer={deleteselectedcustomer}
          customertodelete={customertodelete}
          statedeletingcustomer={statedeletingcustomer}
          cannotDeletecustomer={cannotDeletecustomer}
          handleClose={() => setModalshowdelete(false)}
        />
      )}
    </>)
}
export default CustomersHome
